import React from 'react';
export const Testimonials = () => {
  return <section className="w-full bg-gradient-to-b from-pink-50 to-white py-12 px-4 md:px-8" data-id="element-403">
      <div className="max-w-5xl mx-auto" data-id="element-404">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2 text-center" data-id="element-405">
          "A gdyby istniał sposób?"
        </h2>
        <p className="text-gray-700 text-center mb-8" data-id="element-406">
          Było już 3 nad ranem. Czytałam historie innych kobiet, badania,
          artykuły. I nagle, na jednym z forów dla opiekunów, zobaczyłam post:
        </p>
        {/* Forum post */}
        <div className="bg-white rounded-lg shadow-md border border-gray-200 p-6 mb-8" data-id="element-407">
          <div className="flex items-start mb-4" data-id="element-408">
            <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="Użytkowniczka forum" className="w-10 h-10 rounded-full mr-3" data-id="element-409" />
            <div data-id="element-410">
              <p className="font-bold text-gray-800" data-id="element-411">Monika78</p>
              <p className="text-xs text-gray-500" data-id="element-412">Wczoraj, 03:12</p>
            </div>
          </div>
          <p className="text-gray-700 mb-4" data-id="element-413">
            <span className="font-bold" data-id="element-414">Dziewczyny, zmieniło mi to życie!</span>{' '}
            E-book 'Nie Zapomnij o Sobie'. Nie wierzyłam, że to możliwe, ale
            naprawdę działa. Pierwszy raz od lat czuję, że wracam do siebie.
          </p>
          <div className="flex mb-2" data-id="element-415">
            <svg className="h-5 w-5 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-416">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-417" />
            </svg>
            <svg className="h-5 w-5 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-418">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-419" />
            </svg>
            <svg className="h-5 w-5 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-420">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-421" />
            </svg>
            <svg className="h-5 w-5 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-422">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-423" />
            </svg>
            <svg className="h-5 w-5 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-424">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-425" />
            </svg>
          </div>
        </div>
        {/* Comments */}
        <div className="space-y-6 mb-12" data-id="element-426">
          <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-gray-300 ml-6" data-id="element-427">
            <p className="text-gray-700 mb-2" data-id="element-428">
              <span className="font-bold" data-id="element-429">Ania_K:</span> Też kupiłam i jestem w
              szoku. To nie jest kolejny poradnik o 'zarządzaniu czasem'. To coś
              zupełnie innego.
            </p>
            <div className="flex" data-id="element-430">
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-431">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-432" />
              </svg>
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-433">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-434" />
              </svg>
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-435">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-436" />
              </svg>
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-437">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-438" />
              </svg>
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-439">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-440" />
              </svg>
            </div>
          </div>
          <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-gray-300 ml-6" data-id="element-441">
            <p className="text-gray-700 mb-2" data-id="element-442">
              <span className="font-bold" data-id="element-443">Mama_Trójki:</span> Płakałam czytając.
              Pierwszy raz ktoś naprawdę rozumie, przez co przechodzimy.
            </p>
            <div className="flex" data-id="element-444">
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-445">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-446" />
              </svg>
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-447">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-448" />
              </svg>
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-449">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-450" />
              </svg>
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-451">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-452" />
              </svg>
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-453">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-454" />
              </svg>
            </div>
          </div>
          <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-gray-300 ml-6" data-id="element-455">
            <p className="text-gray-700 mb-2" data-id="element-456">
              <span className="font-bold" data-id="element-457">Karolina42:</span> 3 tygodnie stosuję
              tę 15-minutową metodę i mąż mówi, że jestem jak nowa osoba. A ja
              po prostu przestałam być wiecznie wkurzona.
            </p>
            <div className="flex" data-id="element-458">
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-459">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-460" />
              </svg>
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-461">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-462" />
              </svg>
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-463">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-464" />
              </svg>
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-465">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-466" />
              </svg>
              <svg className="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24" data-id="element-467">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-468" />
              </svg>
            </div>
          </div>
        </div>
        {/* More comments with e-book details */}
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-12" data-id="element-469">
          <p className="text-gray-700 mb-4" data-id="element-470">
            Zaciekawiona, przeczytałam więcej komentarzy:
          </p>
          <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-blue-500 mb-4" data-id="element-471">
            <p className="text-gray-700" data-id="element-472">
              <span className="font-bold" data-id="element-473">Ewa_M:</span> "To są te same badania
              dr Radackiej! Dokładnie ta sama metoda 15-minutowej regeneracji,
              ale opisana tak, żeby każda mama mogła to zrozumieć i zastosować."
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-blue-500" data-id="element-474">
            <p className="text-gray-700" data-id="element-475">
              <span className="font-bold" data-id="element-476">Dorota55:</span> "Nie muszę już
              ukrywać się w łazience, żeby popłakać. Mam swoje 15 minut i to
              wystarczy."
            </p>
          </div>
        </div>
        {/* Decision moment */}
        <div className="bg-gray-100 rounded-lg shadow-md p-6 md:p-8" data-id="element-477">
          <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-478">
            Wahałam się całą noc
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-479">
            Z jednej strony - kolejny e-book? Serio? Ile już ich przeczytałam i
            nic nie pomogło?
          </p>
          <p className="text-gray-700 mb-4" data-id="element-480">
            Z drugiej - te kobiety pisały dokładnie o tym, co ja czułam. Jakby
            ktoś zajrzał do mojej głowy.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-481">
            A przede wszystkim - pisały o tej samej metodzie dr Radackiej, o
            której czytałam przez pół nocy.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-482">
            O 4 rano, kompletnie niewypana, kliknęłam "kup teraz". Co miałam do
            stracenia? 27,99 zł? Tyle wydaję na kawę w tydzień.
          </p>
          <p className="text-gray-700 font-bold" data-id="element-483">
            E-book pobrał się od razu. Zaczęłam czytać...
          </p>
        </div>
      </div>
    </section>;
};